<template>
  <div>
    <div class="header">
      <a href="/" class="logo">
        <img :src="lm == 0 ? logo1 : logo" />
      </a>
      
      <ul class="nav">
        <li :class="idx == 1 ? 'on' : ''">
          <a href="/">首页</a>
        </li>
        <li :class="idx == 2 ? 'on' : ''">
          <a href="javascript:;" @click="$router.push('product')">关于产品</a>

          <div class="productHead">
            <div class="cateLeft">
              <span :class="inx == i ? 'curt' : ''" v-for="(item,i) in setProducthead">{{item.title}}</span>
            </div>
            <div class="cateRight">
              <h3>{{setProducthead[inx].title}}</h3>
              <p class="desc">{{setProducthead[inx].brief}}</p>
              <div class="listPro">
                <div class="item" v-for="(item,i) in setpro" v-if="i<4"  @click="refreshPage(item.id)">
                  <div class="a">
                    <div class="pic"><img :src="baseUrl+item.images" alt=""></div>
                    <h4>{{item.title}}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!--<li :class="idx == 3 ? 'on' : ''">
          <a href="javascript:;" @click="$router.push('trade')">应用场景</a>
          <div class="tradeHead">
            <span href="javascript:;" @click="$router.push('trade?id='+item.id)"  v-for="(item,i) in setTradehead">{{item.title}}</span>
          </div>
        </li>-->
        <li :class="idx == 4 ? 'on' : ''" @click="$router.push('news')">
          <a href="javascript:;">新闻中心</a>
        </li>
        <li :class="idx == 5 ? 'on close' : 'close'">
          <a href="javascript:;" @click="$router.push('about')">关于我们</a>
          <div class="tradeHead">
            <span href="javascript:;" @click="$router.push('about')">企业介绍</span>
            <span href="javascript:;" @click="$router.push('hire')">人员招聘</span>
          </div>
        </li>
        <li :class="idx == 6 ? 'on close' : 'close'" @click="$router.push('contact')">
          <a href="javascript:;">联系我们</a>
        </li>
        <li :class="idx == 7 ? 'on close' : 'close'" @click="$router.push('consult')">
          <a href="javascript:;">业务咨询</a>
        </li>
        <li :class="idx == 8 ? 'on close' : 'close'" style="float:right;">
          <a href="javascript:;">中文<i class="el-icon-arrow-down"></i></a>
          <div class="tradeHead" style="width:110px">
            <span href="javascript:;" >简体中文</span>
            <span href="javascript:;">English</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import $ from 'jquery'
  export default {
    data() {
      return {
        baseUrl:'',
        setTradehead:[],
        setProducthead:[],
        inx:0,
        setpro:[],
        logo:require('../../assets/images/logo.png'),
        logo1:require('../../assets/images/logo1.png'),
      }
    },
    beforeMount() {
      this.baseUrl = this.$fileurl;
    },
    mounted() {
      //this.getTradehead();
      this.getProducthead();

    },

    methods: {
      refreshPage:function(id){
        window.location.href = 'detail?id='+id;
      },
      getTradehead:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/trade',
          dataType:'json',
          success:function(data){
            that.setTradehead = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getProducthead:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/product',
          dataType:'json',
          success:function(data){
            that.setProducthead = data.data;
            that.setpro = data.data[that.inx].jsonStr;
            that.fullscreenLoading = false;
            $(document).ready(function(){
              $(".productHead .cateLeft span").mouseenter(function(){
                $(".productHead .cateLeft span").removeClass('curt')
                that.inx = $(this).index();
                that.setpro = data.data[that.inx].jsonStr;
              });
            });
          }
        })
      },
    },
    props: ['idx','lm']
  }
</script>

<style>
  .header{
    width: 100%;
    height: 96px;
    background:#fff;
    position:fixed;
    top:0;
    left:0;
    z-index:99
  }
  .header .logo{
    position: absolute;
    top: 0;
    font-size: 0;
  }
  .header .logo img{
    height:44px;
    margin:26px 23px 0 24px
  }
  .header .nav{
    text-align:center;
    font-size: 0;
  }
  .header .nav li{
    display:inline-block;
    position: relative;
    margin: 0 1.416vw;
  }
  .header .nav li a{
    font-size: 0.95vw;
    line-height:96px;
    padding: 0 0.520vw;
    color: #333;
    text-decoration: none;
    position: relative;
    display:block;
  }
  .header .nav li.on a{
    font-weight:bold
  }
  .header .nav li.on a::after,.nav li:hover a:after {
    content: '';
    position: absolute;
    bottom: 15px;
    height: 2px;
    background-color: #01248C;
    border: 1px solid #01248C;
    transition: .5s;
    -ms-transition: .5s;
    -moz-transition: .5s;
    -webkit-transition: .5s;
    -o-transition: .5s;
    left: 20%;
    border-radius: 5px;
    right: 20%;
  }
  .nav li:hover a,.nav li.on a{color: #01248C;}
  .nav li:hover .tradeHead,.header li:hover .productHead{
    display:block;
  }
  .header .nav .tradeHead{
    position: absolute;
    background:#fff;
    top:96px;
    width:150px;
    left:0;
    display:none;
    box-shadow: 0px 0px 10px rgba(0,0,0,.1)
  }
  .header .nav .tradeHead span{
    font-size:16px;
    display:block;
    padding: 12px 0;
    cursor: pointer;
  }
  .header .nav .tradeHead span:hover{
    color:#4470AF
  }

  .header .nav .productHead{
    position: fixed;
    left: 0;
    right: 0;
    overflow: hidden;
    background-color: #fff;
    border-top: 1px solid rgba(220,220,220,.5);
    top:96px;
    height: 612.967px;
    display:none;
    z-index:999
  }

  .header .nav .productHead .cateLeft{
    width: 25.93vw;
    background:rgba(0,0,0,.01);
    height: 612.967px;
    padding-top:50px;
    float:left;
  }
  .header .nav .productHead .cateLeft span{
    display:block;
    font-size:16px;
    text-align:left;
    width:70%;
    margin:0 auto;
    padding:20px 0;
    color:#333;
    cursor: pointer;
  }
  .header .nav .productHead .cateLeft span:hover,.header .nav .productHead .cateLeft span.curt{
    color:#01248C;
    font-weight:bold;
  }
  .header .nav .productHead .cateRight{
    float:left;
    width:40.88vw;
    margin-left:3vw;
    padding-top:50px;
  }
  .header .nav .productHead .cateRight .listPro:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .header .nav .productHead .cateRight h3{
    color:#000;
    font-size:20px;
    text-align:left;
    padding:12px 0 0 12px;
  }
  .header .nav .productHead .cateRight .desc{
    color:#666;
    font-size:15px;
    text-align:left;
    line-height:24px;
    padding:20px 0 30px 12px;
  }
  .header .nav .productHead .cateRight .listPro .item{
    width:25%;
    float:left
  }
  .header .nav .productHead .cateRight .listPro .item .a{
    cursor: pointer;
    padding: 0 0.520vw;
  }
  .header .nav .productHead .cateRight .listPro .item .pic{
    border:solid 1px #ccc;
    height: 10.10vw;
    line-height: 10.10vw;

  }
  .header .nav .productHead .cateRight .listPro .item img{
    display: inline-block;
    vertical-align: middle;
    max-width: 80%;
    max-height: 80%;
  }
  .header .nav .productHead .cateRight .listPro .item h4{
    font-size:16px;
    text-align:center;
    color:#333;
    line-height:22px;
    padding-top:15px
  }
  .header .nav .productHead .cateRight .listPro .item:hover h4{
    color:#4470AF
  }
</style>9
